const PROD_BACKEND_URL = "https://api.takamorirobot.com";
const DEV_BACKEND_URL = "http://localhost:5001";

const rawBackendUrl =
  process.env.REACT_APP_BACKEND_API_URL ||
  (process.env.NODE_ENV === "production" ? PROD_BACKEND_URL : DEV_BACKEND_URL);

if (!rawBackendUrl) {
  throw new Error("Missing backend API URL");
}

if (rawBackendUrl.includes("__BACKEND_URL__")) {
  throw new Error(
    "Invalid backend API URL: __BACKEND_URL__. Set REACT_APP_BACKEND_API_URL=https://api.takamorirobot.com"
  );
}

const backendUrl = rawBackendUrl.replace(/\/+$/, "");

export default backendUrl;